import { PracticeExamBottomsheetComponent } from '../../../../partials/practice-exam-bottomsheet/practice-exam-bottomsheet.component';
import { ChangeDetectorRef, Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { MatBottomSheet } from '@angular/material/bottom-sheet';
import { ScoreBottomSheetComponent } from '../../../auth/score-bottom-sheet/score-bottom-sheet.component';
import { BuyComponent } from '../../../../partials/buy/buy.component';
import { ExamLoginComponent } from 'src/app/views/partials/exam-login/exam-login.component';
import { ResultExamDialogComponent } from '../../../../partials/dialogs/result-exam-dialog/result-exam-dialog.component';
import {
  MatLegacyDialog as MatDialog,
  MatLegacyDialogConfig as MatDialogConfig,
} from '@angular/material/legacy-dialog';
import { ExamLoginBottomsheetComponent } from 'src/app/views/partials/exam-login-bottomsheet/exam-login-bottomsheet.component';
import { GetUserBoughtExamsService } from 'src/app/shared/services/api/exam/get_user_bought_exams.service';
import { Router } from '@angular/router';
import { AuthService } from '../../../auth/auth.service';
import { LoginBottomSheetComponent } from '../../../auth/login-bottom-sheet/login-bottom-sheet.component';
import { GetUserNotBoughtExamsService } from 'src/app/shared/services/api/exam/get_user_not_bought_exams.service';
import { BuyExamDialogComponent } from 'src/app/views/partials/dialogs/buy-exam-dialog/buy-exam-dialog.component';
import { Subscription } from 'rxjs';
import { GetExamAnswerSheetService } from 'src/app/shared/services/api/exam/get_exam_answer_sheet.service';
import { ShowResultDialogComponent } from './show-result-dialog/show-result-dialog.component';
import { GetBooksService } from 'src/app/shared/services/api/book/get_books.service';
import { CookieService } from 'ngx-cookie-service';
import { NgxSpinnerService } from 'ngx-spinner';
import { GetUserAllExamsService } from 'src/app/shared/services/api/exam/get_user_all_exams.service';
import { GetUserAllExamsRequestModel } from 'src/app/shared/api-models/requests/exam/GetUserAllExamsRequestModel';
import { async } from 'rxjs/internal/scheduler/async';
import { GetProductTypesService } from 'src/app/shared/services/api/product/get_product_types_service';
export interface filterResponseModel {
  book_id?: string;
  title?: string;
}

@Component({
  selector: 'app-practice-exam',
  templateUrl: './practice-exam.component.html',
  styleUrls: ['./practice-exam.component.scss'],
})

export class PracticeExamComponent implements OnInit {
  staticFilterList = [
    {
      value: '6d',
      title: 'شش بعدی',
    },
    {
      value: 'jet',
      title: 'جت',
    },
    // {
    //   value: 'conference',
    //   title: 'همایش',
    // },
    // {
    //   value: 'resolved',
    //   title: 'حل شده',
    // },
  ];

  userInfo;
  userBoughtExam;
  userNotBoughtExam;
  userIsLogin: boolean;
  unsubscribes: Subscription[] = [];
  isLoading;
  filters;
  filtersBookId;
  filterdUserExams: any[] = new Array(5).fill(null);;
  // skeletonLoaderArray: any[] = new Array(5).fill(null); // آرایه‌ای با 5 عنصر null

  selectedExamFiters: Array<string> = [

  ];

  userExamFilterRespons;
  selectedStaticExamFiter;
  selectedExamFitersIndex = 0;

  loader: boolean = true;
  // btndisable: boolean = true;
  desc;
  productType = '6d';
  is6d: boolean;
  isJet: boolean;
  isConfrence = false;
  productTypes;
  resolvedSolved = [
    {
      title: 'حل نشده',
      id: '0'
    },
    {
      title: 'حل شده',
      id: '1'
    }
  ];
  selectedProductType
  constructor(
    private bottomsheet: MatBottomSheet,
    private dialog: MatDialog,
    private getUserBoughtExamService: GetUserBoughtExamsService,
    private getUserNotBoughtExamService: GetUserNotBoughtExamsService,
    private router: Router,
    private bottomSheet: MatBottomSheet,
    private auth: AuthService,
    private getExamAnswerSheet: GetExamAnswerSheetService,
    private getBooksService: GetBooksService,
    private cookie: CookieService,
    // private loading: NgxSpinnerService,
    private getUserAllExamsService: GetUserAllExamsService,
    private ref: ChangeDetectorRef,
    private getProductTypesService: GetProductTypesService,

  ) {
    this.userInfo = JSON.parse(localStorage.getItem('userinfo'));
    // console.log('userinfoooo', this.userInfo);
    if (this.auth.isAuthenticated().value == true) {
      this.userIsLogin = false;
    } else {
      this.userIsLogin = true;
    }
  }

  ngOnInit() {
    this.loader = true;
    this.getAllBooks(this.userInfo?.default_grade_id);
    this.selectedProductSolved = this.resolvedSolved[0]?.id
  }
  pageNum = 1;
  pageSize = 10
  getUserAllExams() {
    // console.log('resolved', resolve);

    this.loader = true;
    // this.loading.show();
    const model: GetUserAllExamsRequestModel = {
      grade_ids: [this.userInfo?.default_grade_id],
      exam_types: [10],
      book_ids: this.selectedExamFiters,
      is6d: this.isJet,
      isjet: this.is6d,
      product_type_id: this.selectedProductType
    };
    this.getUserAllExamsService.call(model).subscribe((res: any) => {
      if (res) {
        this.filterdUserExams = []
        // console.log('user all exmassss is :', res, res);
        this.filterdUserExams = res
        this.loader = false;

        // setTimeout(() => {
        //   this.loader = false;
        //   if (this.isResolved === false) {
        //     this.filterdUserExams = this.filterdUserExams.filter((item: any) => {
        //       console.log('userr all exam', res);
        //       item?.is_resolved === false
        //       return item.is_resolved === false
        //     })
        //     this.ref.detectChanges();
        //     console.log('userr all exam', res);
        //   } else if (this.isResolved === true) {
        //     this.filterdUserExams = this.filterdUserExams.filter((item: any) => {
        //       console.log('userr all exam', res);
        //       item?.is_resolved === true
        //       return item.is_resolved === true

        //     })
        //   }
        //   this.loader = false;
        // }, 1000)
      }

    },
      () => {
        // this.loading.show();
      }
    );
  }
  loadmore() {
    // this.blogList.items = [
    //   ...this.blogList.items,
    //   ...res?.items
    // ]
    this.pageNum++;
    this.getUserAllExams();
  }
  chooseProductType
  getProductTypes() {
    this.getProductTypesService.call().subscribe(res => {
      // console.log('this.productCatttttttt typeeeeeeeeeeeeeeeeeeeeee', res);
      this.productTypes = res
      this.selectedProductType = res[0].id;
      this.chooseProductType = res[0]
      const isResolved = false;
      this.getUserAllExams();

    })
  }
  changeStaticFilter(productType) {
    // console.log('this.chooseProductType', productType);
    this.selectedProductType = productType.id;
    this.chooseProductType = productType
    const isResolved = false;
    this.getUserAllExams();
  }
  selectedProductSolved;
  isResolved = false;
  changeSolvedFilter(item) {
    // console.log('this.changeSolvedFilter', item.id, item);
    this.selectedProductSolved = item?.id
    if (item.id === '0') {
      this.isResolved = false;
      this.getUserAllExams();
      // console.log('this.changeSolvedFilter is ', item.id);

    } else if (item.id === '1') {
      this.isResolved = true;
      this.getUserAllExams();
      // console.log('this.changeSolvedFilter is ', item.id);

    }
  }
  changeFilter(bookId, i) {
    // console.log('bokkId', bookId);

    this.selectedExamFiters = [];
    this.selectedExamFitersIndex = i;
    this.selectedExamFiters?.push(bookId);
    // console.log('selectedExamFiters', this.selectedExamFiters);

    this.getUserAllExams();

  }
  getAllBooks(gradeId) {
    this.getBooksService.call(gradeId).subscribe(res => {
      // console.log('get booksssssss ressssssss ', res);
      this.filtersBookId = res;
      this.selectedExamFiters.push(this.filtersBookId[0].book_id);
      if (res) {
        this.getProductTypes()
      }
    });
  }
  resultSkl = false;
  selectedIndex;
  onGoToResult(examId, title, i) {
    this.selectedIndex = i;
    // if (this.selectedIndex == i) {
    //   this.resultSkl = true;
    // }
    // console.log(examId, title, 'iiiiiiiiiiiiiiiiiiiiiiiii', i);
    // this.loading.show();
    this.getExamAnswerSheet.call(examId,'').subscribe(
      (res) => {
        if (res) {
          this.selectedIndex = null
          // console.log('examAnswerSheet', res);
          this.dialog.open(ShowResultDialogComponent, {
            // disableClose: true,
            data: { data: res, title: title, exam_id: examId },
          });
          // this.loading.hide();
        }
      },
      (err) => {
        // this.loading.hide();
      }
    );
  }
  openExam(id) {
    // this.bottomsheet.open(ExamLoginBottomsheetComponent);
    this.router.navigate(['exam'], {
      queryParams: { examId: id, examType: '2' },
    });
  }

  onLoginBottomSheet() {
    const bottomSheetRef = this.bottomSheet.open(LoginBottomSheetComponent, {
      data: {
        loginState: 'login',
      },
    });
    bottomSheetRef.afterDismissed().subscribe((result) => {
      if (result.res.access_token) {
        window.location.reload();
      }
    });
  }
  openDialogBuyProduct(exam_id, title) {
    const dialogConfig = new MatDialogConfig();

    dialogConfig.data = { model: { exam_id, discount_code: null }, title };

    const dialogRef = this.dialog.open(BuyExamDialogComponent, dialogConfig);
    const sub = dialogRef.backdropClick().subscribe(() => {
      dialogRef.close();
    });
    this.unsubscribes.push(sub);
  }

  openBuyComponent(id, title, des, mode) {
    if (mode === true) {
      mode = 'buy'
    }
    else {
      mode = 'gift'
    }
    // this.bottomsheet.open(BuyExamDialogComponent);
    const bottomSheet = this.bottomsheet.open(BuyComponent, {
      data: {
        examId: id,
        examTitle: title,
        examDes: des,
        mode: mode
      },
    });
    bottomSheet.afterDismissed().subscribe((result) => {
      // this.getUserBoughExams(this.userInfo?.default_grade_id);
      // this.getUserNotBoughtExam(this.userInfo?.default_grade_id);
      if (result != undefined) {
        this.getUserAllExams();
      } else {
        return
      }
    });
  }



  openDesctiptionBottomsheet(desc, title): void {
    this.bottomSheet.open(PracticeExamBottomsheetComponent, {
      data: {
        desc: desc,
        title: title
      },
    });
  }

}

